module.exports = __webpack_public_path__ + "img/img39.5c6998c7.svg";